module.exports = __webpack_public_path__ + "static/media/acronyms.74aea95b.sqlite";